class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.threshold = parseInt(this.getAttribute('threshold') || '300', 10);
    this.btn = null;
    this._onScroll = this._onScroll.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    if (this.btn) return;

    this._createButton();
    window.addEventListener('scroll', this._onScroll, { passive: true });
    this.btn.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    this.btn?.removeEventListener('click', this._onClick);
  }

  _createButton() {
    const label = this.getAttribute('aria-label') || 'מעבר לראש העמוד';

    const btn = document.createElement('button');
    btn.id = 'goToTop';
    btn.type = 'button';
    btn.className = 'back-to-top-btn';
    btn.setAttribute('aria-label', label);

    btn.innerHTML = `
      <span class="back-to-top-btn__icon" aria-hidden="true"></span>
      <span class="back-to-top-btn__label">
          <svg version="1.1" id="fi_130906" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 240.835 240.835" style="enable-background:new 0 0 240.835 240.835;" xml:space="preserve">
              <g>
                <path id="Expand_Less" d="M129.007,57.819c-4.68-4.68-12.499-4.68-17.191,0L3.555,165.803c-4.74,4.74-4.74,12.427,0,17.155
                  c4.74,4.74,12.439,4.74,17.179,0l99.683-99.406l99.671,99.418c4.752,4.74,12.439,4.74,17.191,0c4.74-4.74,4.74-12.427,0-17.155
                  L129.007,57.819z"></path>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
        </svg>
    <span>UP</span>
      </span>
    `;

    this.appendChild(btn);
    this.btn = btn;
  }

   _shouldShow() {
    if (this.visibility === "mobile" && window.innerWidth > 768) return false;
    if (this.visibility === "desktop" && window.innerWidth <= 768) return false;
    return true;
  }

  _onScroll() {
    if (!this.btn) return;

    if (window.scrollY > this.threshold) {
      this.btn.classList.add('visible');
    } else {
      this.btn.classList.remove('visible');
    }
  }

  _onClick(e) {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('back-to-top-button', BackToTopButton);
